import React from 'react';

import styles from './consentDetails.scss';

interface ConsentDetailsProps {
  title: string;
  value?: string;
}

const ConsentDetails = ({ title, value = '' }: ConsentDetailsProps) => (
  <p className={styles.wrapper} key={title}>
    <span className={styles.title} dangerouslySetInnerHTML={{ __html: `${title}:` }} />
    <span dangerouslySetInnerHTML={{ __html: value }} />
  </p>
);

export default ConsentDetails;
